interface PremiumGateProps {
  children:  React.ReactNode
  isPremium: boolean
}
export default function PremiumGate({ children, isPremium }: PremiumGateProps) {
  if (isPremium) return <>{children}</>
  return (
    <div className="relative">
      {/* Blurred content visible behind the overlay */}
      <div className="blur-sm pointer-events-none select-none opacity-60">
        {children}
      </div>
      {/* Lock overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-center
                      bg-white/70 backdrop-blur-sm rounded-2xl border border-border">
        <span className="text-4xl mb-3"></span>
        <p className="font-semibold text-text-primary text-lg">Unlock Pantry +</p>
        <p className="text-text-secondary text-sm mt-1">$4.99/month or $39.99/year</p>
        <button
          onClick={() => { window.location.href = '/paywall' }}
          className="mt-4 bg-green text-white px-6 py-2 rounded-xl font-medium
                     hover:opacity-90 transition-opacity"
        >
          Upgrade
        </button>
      </div>
    </div>
  )
}